import React from 'react';
import classNames from 'classnames';
import { AlertCircle, Info } from 'react-feather';
import PropTypes from 'prop-types';

const iconClasses = 'fs-0 mr-16';

export const BANNER_TYPES = {
  ERROR: 'error',
  WARNING: 'warning',
};

const { ERROR, WARNING } = BANNER_TYPES;

const MessageBanner = ({ message, type }) => {
  const bannerClasses = classNames(
    'ErrorContainer Animated--fadeIn mb-16 d-f ai-c',
    {
      'ErrorContainer--error': type === ERROR,
      'ErrorContainer--informational': type === WARNING,
    },
  );

  const icon =
    type === ERROR ? (
      <AlertCircle size={16} className={iconClasses} />
    ) : (
      <Info size={16} className={iconClasses} />
    );

  return (
    <div
      className={bannerClasses}
      role="alert"
      aria-live="assertive"
      data-testid="NotificationBanner"
    >
      {icon}
      <span className="text-wrap">{message}</span>
    </div>
  );
};

MessageBanner.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(Object.values(BANNER_TYPES)).isRequired,
};

export default MessageBanner;
